<template>
  <div>
     <v-init-view>
      <p slot="right" class="link" @click="closeEvent"><span class="fa fa-close "></span>关闭当前页 </p>
      <div class="container ">
        <div class="agreement-container">
          <h2 class="title">e农平台用户服务协议</h2>
          <p>欢迎您来到e农！请在使用e农服务前，阅读并遵守《e农用户服务协议》 (以下简称“本协议”），并在进一步操作前仔细阅读、充分理解本协议的各个条款，尤其是以加粗形式提示您注意的条款。您有权选择同意或不同意本协议，如果您点击“我已阅读并同意”按纽，即视为您已阅读并接受本协议的所有条款。您完成注册程序或使用第三方账号登录e农平台，使用e农服务平台，即视为您已充分阅读、理解本协议，并自愿接受本协议的全部条款。阅读本协议过程中，如果您不同意本协议或其中任何条款，请立即停止注册程序并停止使用e农服务平台。
            本“温馨提示”是本协议正文的组成部分。</p>
          <p class="bold">1.0  定义</p>
          <p>1.1 e农平台：是指华农农服（北京）网络科技有限公司经营的电商平台，包括但不限于e农网站（www.e-nongye.com.cn)、e农客户端及 e农微信商城。</p>
          <p>1.2 e农：是指e农平台的提供者及经营者，即华农农服（北京）网络科技有限公司。e农仅为第三方入驻商户（以下简称“商户”或“销售方”）与您达成交易，提供虚拟经营场所、网页空间、交易规则等服务，并非商户与您交易行为的参与方，不对商户及/或您的任何口头、书面陈述或承诺，发布的信息及交易行为的合法性、真实性、准确性、有效性和及时性等提供任何明示或暗示的保证，亦不承担任何法律责任。您完全理解并同意，e农基于平台管理和保护消费者利益的需要，依据e农与商户之间的约定及/或平台规则，督促商户履行其对您作出的承诺或赔付责任，但这并不意味着e农须承担与此相关的任何法律责任（包括但不限于连带责任、补充责任和担保责任等）</p>
          <p>1.3 e农规则：包括所有e农已经发布或将来可能发布、修订的各类规范、规范解读、公告、通知和实施细则等。</p>
          <p>1.4.e农平台用户服务协议：即指本协议，是您与e农订立的旨在约定您登录、使用e农平台，以及通过e农平台下达订单、购买商品、支付货款、收取商品等整个网购过程中，您与e农达成的权利、义务规定。</p>
          <p class="bold">2.0  协议内容及变更</p>
          <p>2.1 本协议内容包括协议正文及e农规则。所有规则均为本协议组成部分，与协议具有同等法律效力。</p>
          <p>2.2 如您在首次使用e农平台时，未及时签署本协议的，您的使用行为视为对本协议的同意，本协议效力将溯及至您首次使用e农平台之日。</p>
          <p>2.3 为给您提供更好的服务，e农将根据业务变化，相应调整本协议。e农将对修订内容提前予以公示，修订后的协议一经实施，将完全替代修订前的协议。您应当及时关注和了解本协议的修订情况、公吿、提示信息等，如果您不同意修订后协议，请您立即停止使用e农平台，否则即视为您同意并完全接受修订后的协议。。</p>
          <p class="bold">3.0 用户账户</p>
          <p>3.1 在注册e农用户账户之前，您应当确认并承诺，您具备中华人民共和国法律规定的完全民事行为能力。</p>
          <p>3.2 您可以通过注册e农用户账户或使用第三方账号（例如微博账号、微信账号等）登录并使用e农平台。</p>
          <p>3.3 注册e农用户账户时，您应当提供真实、有效的信息（包括姓名、电子邮箱、联系电话、联系地址等）；同时，您应当保证上述信息的持续有效性，一旦信息发生变化，您应当及时进行更新。否则，您应当承担因信息提供不真实、联系方式无效导致的相关不利后果及全部损失，且e农保留终止向您提供服务的权利。</p>
          <p>3.4 您的账户由您自行设置并保管，e农任何时候均不会主动要求您提供您的账户密码。因您保管账户、密码不当而造成的所有后果，将由您自行承担。凡经您的账户和密码成功登录使用e农平台，即视为您的使用行为；您应当对您的账户进行的所有活动及后果承担法律责任。您不得以任何形式擅自转让或授权他人使用您的账户，因您主动泄露、出售帐户信息或因您遭受他人攻击、诈骗等行为导致的损失及后果，e农并不承担责任。您可以通过行政、司法等救济途径向侵权行为人追偿。</p>
          <p class="bold">4.0 商品及/或服务的购买</p>
          <p>4.1 请您在e农平台购买商品或服务时，务必仔细确认所购商品的名称、价格、规格、数量、尺寸、型号或服务的内容、时间和限制性要求等重要事项，并在下单时进一步确认您的电话、收货人和联系地址等信息。如您填写的收货人非您本人，该收货人的行为和意思表示产生的法律后果均由您承担。</p>
          <p>4.2 您的购买行为应当基于真实的消费需求，不得实施恶意购买、恶意维权等扰乱e农平台正常交易秩序的行为。基于维护e农平台交易秩序及交易安全的需要，e农发现上述情形时有权采取关闭相关交易订单，限制账户使用功能、中止或终止服务等措施而无需事先通知您。 </p>
          <p>4.3 e农保留对单个商品的总出售数量进行限制、对单个订单的商品购买数量及同一IP地址对同类商品购买数量进行限制，并对异常订单、异常用户采取监控、限制等措施的权利。如e农发现您下达的订单存在违反法律规定或者本协议约定的异常情形的，e农有权采取关闭相关交易订单、限制账户使用功能、中止或终止服务等措施而无需事先通知您。</p>
          <p>4.4 您通过e农平台下达订单后，仅表示系统接收到了您下达的订单，只有销售方将订单中的商品实际向您发出时（以销售方点击发货的时间为准），您与销售方之间的买卖合同才成立。此外，如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就销售方已经经发出的那一部分商品成立买卖合同。</p>
          <p>4.5 您有权在e农平台提供的评价系统中对您购买的商品或服务进行评价。您的所有评价行为应遵守e农规则的相关规定，评价内容应当客观真实，不得包含任何污言秽语、色情低俗语言、广告信息、法律法规及本协议规定的其他禁止性信息；您不得以任何不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。e农可以按照法律法规及/或e农规则的相关规定对您发布的违规评价信息讲行删除或屏蔽。</p>
          <p>4.6 除另有明确说明外，e农平台上销售的商品/服务的相关信息由商户自行制作、上传，e农尽可能通过与商户签订合作协议及发布平台规则等方式约束商户提供准确、完整、有效、可靠、无错误和无误导性的商品描述。然而，您充分理解并认可，e农平台上存在海量信息，因为互联网技术及人力的局限性，e农不能保证平台上所有商品的信息均准确、完整、有效、可靠、无错误和无误导性。除e农的故意行为并具有明显过错外，对于因商品信息导致的纠纷，e农不承担任何责任。</p>
          <p>4.7 如果您使用e农平台时存在违反国家法律法规、本协议规定，侵害e农、他人利益或社会公共利益、严重违背社会公德等情形，e农有权采取删除相关信息、中止或终止提供服务等处理措施。</p>
          <p>4.8 您充分理解并认可，因您违反本协议或e农规则而产生的第三方索赔请求，由您自行承担法律责任，由此导致e农遭受损失的，您应当予以赔偿。</p>
          <p class="bold">5.0 费用</p>
          <p>5.1 除e农另有规定外，e农平台暂时为您提供免费服务，不向您收取任何费用。但e农保留收费的权利，包括设置收费的软件功能，决定收费对象、收费时段或收费费率等。</p>
          <p>5.2 e农在收费前，会通过本协议或e农规则约定的方式提前通知，若您不同意e农的收费规则，应当立即停止使用e农平台；如果您继续使用e农平台，则视为您接受相关收费规则，您应当遵照收费规则向e农支付相应的费用</p>
          <p class="bold">6.0 所有权及知识产权</p>
          <p>6.1 e农提供的服务中包含的任何编码、商标、服务标志、商号、图形、美术品、照片、肖像、文字内容、音频、视频、按钮图标以及计算机软件、标识、数码下载、数据汇编等都是e农或其内容提供者的财产，受到中华人民共和国版权、商标权和其他财产所有权法律法规的保护。</p>
          <p>6.2 对于您在任何时间以任何形式向e农提供或在e农平台发表的信息或资料（包括但不限于文字、图片、音频、视频等）相关知识产权，您同意免费授予e农及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用的权利。您同意e农及其关联公司存储、使用、修订、复制、发布、编辑、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其他作品内。</p>
          <p class="bold">7.0 用户守则</p>
          <p>7.1 您不得进行任何侵犯e农知识产权的行为，或者进行其他的有损于e农或其他用户合法权益的行为，包括但不限于：</p>
          <p>7.1.1 删除或修改e农平台上的版权信息；</p>
          <p>7.1.2 在e农平台中内置各种插件程序或其他第三方程序，或者制作、发布、传播上述程序，而无论是否出于商业目的</p>
          <p>7.1.3 对e农平台及其中的相关信息擅自出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，借助e农平台发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；</p>
          <p>7.1.4 冒充e农或商户在e农平台当中发布任何诈骗或虚假信息；</p>
          <p>7.1.5 进行编译、反编译、反向工程或者以其他方式破解e农平台的行为；</p>
          <p>7.1.6 使用e农平台外挂和/或利用e农平台当中的BUG来获得不正当的利益；</p>
          <p>7.1.7 利用劫持域名服务器等技术非法侵入、破坏e农平台的服务器软件系统，或者修改、增加、删除、窃取、截留、替换e农平台的客户端和/或服务器软件系统中的数据，或者非法挤占e农平台的服务器空间，或者实施其他的使之超负荷运行的行为；</p>
          <p>7.1.8 利用e农平台故意传播恶意程序或计算机病毒。</p>
          <p>7.2 您应当遵守国家有关法律法规，不得在e农平台当中发表、转发或者传播包括但不限于下列内容的信息：</p>
          <p>7.2.1 反对宪法所确定的基本原则的；</p>
          <p>7.2.2 危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的;</p>
          <p>7.2.3 损害国家荣誉和利益的；</p>
          <p>7.2.4 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>7.2.5 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>7.2.6 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>7.2.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>7.2.8 侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>7.2.9 法律、行政法规禁止的其他内容的。</p>
          <p>7.3 您需要对您在e农平台的言论及行为承担法律责任，若您违反国家法律法规的规定，e农平台的系统记录有可能成为您违反法律法规的证据。</p>
          <p class="bold">8.0 有限责任</p>
          <p>8.1 您理解并认可，e农并非司法机关等专业机构，仅能以普通或非专业人员的知识水平标准对各方提交的材料信息进行鉴别，若您与销售方之间发生纠纷并希望e农介入处理，e农对交易纠纷的调处完全是基于您和/或商户的委托，e农无法保证交易纠纷处理结果符合您和/或商户的期望，也不对交易纠纷调处结果及赔付决定承担任何责任。</p>
          <p>8.2 除法律法规规定外，e农有权单方面中止或者终止e农平台所提供的服务而无须提前通知您。您理解并认可，e农需要定期或者不定期地对e农平台、设备进行维护或者检修，因此造成的e农服务在合理时间内的中断，e农无需为此承担任何责任，但e农将尽可能事先通知您。</p>
          <p>8.3 不论在何种情况下，e农均不对由于Internet连接故障，电脑、 通讯或其他系统的故障，电力故障，计算机病毒，程序漏洞，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，国际、国内法院的命 令或第三方的不作为，不可抗力而导致的不能服务或延迟服务承担责任。</p>
          <p class="bold">9.0 个人信息保护及授权</p>
          <p>9.1 您充分理解并认可e农可能通过e农平台在您自愿选择服务或提供信息的情况下收集您的个人信息，例如您的姓名、地址、电子邮箱、电话号码及其他身份信息等。我们有可能会保留一些用户的使用习惯信息，用于更好地了解和服务用户。这些数据将有利于我们开发出更符合用户需求的功能、信息和服务。</p>
          <p>9.2 e农将使用各种安全技术和程序防止您及其他用户个人信息的丢失、不当使用、未经授权阅览或披露。但您充分理解并同意：由于技术的限制以及可能存存的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。</p>
          <p>9.3 e农非常重视您的个人信息保护，在您使用e农提供服务时，您同意按照本协议收集、存储、使用、披露和保护您的个人信息。</p>
          <p>9.4 居于商户与用户之间的销售与购买关系，用户同意其商户获取其关联的交易数据、用户数据及服务信息；出于为用户提供服务的目的，用户同意e农平台将相关信息提供给网库的关联方及合作方；为了给用户提供精准的种植管理建议，e农平台将用户的信息提供给专业的农技人员或组织；为帮助用户更加便捷的获取到金融服务，e农平台可向合作的金融机构共享用户的必要信息用于授信评估。</p>
          <p>9.5 您在e农平台提交的采购订单如有融资需求的，可事先通过e农平台向入驻平台的金融服务商提交授信申请及相关资料，待取得金融服务商批复的授信额度后，可配比真实交易订单使用授信额度内的贷款，具体操作要求按照金融服务商的规定完成。</p>
          <p>9.6 对于授信、赊销的应收账款，您同意转让或作为质押。应收账款提供不真实信息的，承担相应的法律责任。对融资的质押或转让债权，您应按照债权人及金融服务商的要求，在约定的期限内还款到指定账户，并在e农平台作及时的核销。</p>
          <p>9.7 您申请贷款、授信服务时，视为您同意金融机构对您的企业和法定代表人进行征信系统查询。</p>
          <p>9.8 e农有权向您收取贷款融资服务费用。e农拥有制订及调整服务费用的权利，具体服务费用标准及收取规则将以网站公示的方式进行公告，不再单独通知您。自公告施行之日公告内容构成对e农与会员间协议约定的有效修改和补充。如果您不同意接受e农有关公告的内容，应当立即停止使用该等服务费用相关的e农平台服务。您继续使用与该等服务费用相关的e农平台服务的，即视为您接受e农公告的服务费用标准及收取规则。</p>
          <p class="bold">10.0 期限、解除和终止</p>
          <p>10.1 本协议自您确认同意之日起生效并长期有效。</p>
          <p>10.2 出现以下情况时，e农可以本协议规定的方式通知您终止本协议：</p>
          <p>10.2.1 您违反本协议规定，e农依据违约条款终止本协议的；</p>
          <p>10.2.2 您的账户被e农依据本协议回收的；</p>
          <p>10.2.3 您盗用他人账户、发布违禁信息、骗取他人财物、扰乱市场秩序、采取不正当手段谋利等行为，e农依据法律和e农规则对您的账户予以冻结的；</p>
          <p>10.2.4 除上述情形外，因您多次违反e农规则相关规定且情节严重，e农依据e农规则对您的账户予以冻结的；</p>
          <p>10.2.5 其它应当终止服务的情况。</p>
          <p>10.3 协议终止或解除后的后续事项处理：</p>
          <p>10.3.1 自本协议终止或解除之日起，e农将关闭您在e农平台的账户权限。</p>
          <p>10.3.2 本协议终止或解除后，e农有权保留您的注册信息及交易行为记录等数据，但e农没有为您保留这些数据的义务，亦不承担在协议终止后向您或第三方提供任何数据信息的义务，也不就协议终止向您或任何苐三方承担责任，但法律法规另有规定的除外。</p>
          <p>10.3.3 本协议终止或解除后，e农仍保留对您过往的违约行为追究责任的权利。</p>
          <p class="bold">11.0 不可抗力</p>
          <p>11.1 由于不可抗力事件导致一方不能及时履行或者不能履行该方在本协议下的任何义务（付款义务除外）的，不构成违约。但是受不可抗力事件影响的一方应立即把不可抗力事件的性质和程度通知对方，并积极采取相应补救措施，以最大程度地减少和避免损失。</p>
          <p class="bold">12.0 法律适用及管辖</p>
          <p>12.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p>
          <p>12.2对于因本协议而产生的或者与本协议有关的争议，双方均应通过友好协商的方式进行解决。协商不成的，任何一方均可向中国国际经济贸易仲裁委员会申请仲裁。</p>
          <p class="bold">13.0 通知</p>
          <p>13.1 您在注册e农平台账户时所填写的联系电话、联系地址、电子邮箱地址视为您的有效通知地址。若上述信息发生变更您应当及时进行更新，如果因您提供的联系方式不准确，或不及时告知变更后的联系方式，使相关通知（包括但不限于协议变更、法律文书等）无法送 达或未及时送达，由您自行承担可能产生的法律后果。</p>
          <p>13.2 e农通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在e农平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮箱发送电子邮件，向您的e农用户账户发送系统消息以及站内信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</p>
          <p>13.3 对于与e农平台有关的任何纠纷，您同意行政、仲裁、司法等有权机构可以通过手机短信、电子邮件、系统消息或站内信息等方式向您送达法律文书，有权机关向上述联系方式发出法律文书即视为送达；若同时采取以上多种方式向您送达法律文书，送达时间以最先送达的为准。您同意上述送达方式适用于行政、仲裁、司法等法定程序全过程。</p>
          <p class="bold">14.0 其他</p>
          <p>14.1 条款的独立性如果根据适用的法律认定本协议中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行性不影响本协议中的任何其它条款或者这些条款中的任何其它部分的效力。</p>
          <p>14.2 本协议未明示授权的其他权利仍由e农保留，用户未经e农书面许可不得行使，且e农未行使前述任何权利并不构成放弃权利。</p>
          <p>14.3 本协议条款的标题仅作参考使用，不界定、影响或限制本协议条款的含义、描述及解释。</p>
          <p>14.4 本协议于2019年1月1日最新修订生效。</p>
        </div>
      </div>
     </v-init-view>
  </div>
</template>

<script>
export default {
  methods:{
      closeEvent(){
        window.opener=null;
        window.close();
      }
  }
}
</script>

<style lang="scss" scoped>
.agreement-container{
  margin-top: 21px;
  border: 1px #e4e4e4 solid;
  background: #fff;
  padding: 0 102px 70px;
  p{
    line-height: 30px;
    font-size:14px;
    color:#666;
  }
  h2{
    padding:60px 0 40px;
    text-align: center;
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight: 700;
    font-size: 20px;
  }
  .bold{
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight:700;
    color:#1ABC9C;
    line-height: 76px;
  }
}
.link{
  cursor: pointer;
  .fa-close{
    margin-right: 5px;
    font-size: 16px;
    color: #1ABC9C;
  }
}
</style>
